/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/DailyChallenges/KlondikeChallenge',[
        'lodash',
        'absolute/stringmanager',
        'absolute/textutils',
        'CardUI/IChallengeDefinition',
        'SolitaireShared/CardLogic/ChallengeConstants',
        'SolitaireShared/CardLogic/Card',
        'SolitaireShared/KlondikeLogic/ChallengeAuthorities/PlayCardDailyKlondikeAuthority',
        'SolitaireShared/KlondikeLogic/ChallengeAuthorities/PlayValuesKlondikeAuthority',
        'SolitaireShared/KlondikeLogic/ChallengeAuthorities/AchieveScoreDailyKlondikeAuthority',
        'SolitaireShared/KlondikeLogic/ChallengeAuthorities/CardToCardDailyKlondikeAuthority',
        'SolitaireShared/KlondikeLogic/ChallengeAuthorities/SolveGameDailyKlondikeAuthority'
    ],
    function (_, _s, TextUtils, IChallengeDefinition, ChallengeConstants, Card, PlayCardDailyKlondikeAuthority, PlayValuesDailyKlondikeAuthority, AchieveScoreDailyKlondikeAuthority, CardToCardDailyKlondikeAuthority, SolveGameDailyKlondikeAuthority) {
        "use strict";

        var KlondikeChallenge = function (challengeType, parameters, config) {
            this.initKlondikeChallenge(challengeType, parameters, config);
        };

        KlondikeChallenge.constructor = KlondikeChallenge;
        KlondikeChallenge.prototype = Object.create(IChallengeDefinition.prototype);

        KlondikeChallenge.GoalType =
        {
            /// <summary>
            /// No Parameters
            /// </summary>
            SolveGame: 0,

            /// <summary>
            /// PARAMETERS: ScoreRequired
            /// </summary>
            AchieveScore: 1,

            /// <summary>
            /// PARAMETERS: StackCard, BaseCard
            /// </summary>
            CardToCard: 2,

            /// <summary>
            /// PARAMETERS: CardToPlay
            /// </summary>
            PlayCard: 3,

            /// <summary>
            /// PARAMETERS: NumToPlay, ValueToPlay
            /// </summary>
            PlayValues: 4
        };

        KlondikeChallenge.prototype.GoalType = KlondikeChallenge.GoalType;

        KlondikeChallenge.prototype.initKlondikeChallenge = function (challengeType, parameters, config) {
            IChallengeDefinition.call(this, challengeType, parameters, config);
        };

        KlondikeChallenge.prototype.ConstructAuthority = function () {
            var authority = KlondikeChallenge.AuthorityTypes[this.ChallengeType](this.Parameters);
            this.SetupOptionsForAuthority(authority);

            return authority;
        };

        KlondikeChallenge.prototype.SetupOptionsForAuthority = function (authority) {
            authority.CardSupply.SetOption("SCORING", this.Parameters["SCORING"]);
            authority.CardSupply.SetOption("DRAW", this.Parameters["DRAW"]);

            IChallengeDefinition.prototype.SetupOptionsForAuthority.call(this, authority);
        };

        KlondikeChallenge.prototype.GetGoalDescription = function () {
            try {
                switch (this.ChallengeType) {
                    case KlondikeChallenge.GoalType.SolveGame:
                        return _s(this.CompleteGoalLocString("DailyChallengeGoal_SolveDeck"),
                            [
                                (this.AllowedTime > 0 ? this.GetTimeFormat(this.AllowedTime) : this.AllowedMoves),
                                this.AllowedMoves
                            ]);
                    case KlondikeChallenge.GoalType.AchieveScore:
                        return _s(this.CompleteGoalLocString("DailyChallengeGoal_AchieveScore"),
                            [
                                TextUtils.formatInt(this.Parameters[ChallengeConstants.KeyScoreRequired]),
                                (this.AllowedTime > 0 ? this.GetTimeFormat(this.AllowedTime) : this.AllowedMoves),
                                this.AllowedMoves
                            ]);
                    case KlondikeChallenge.GoalType.PlayCard:
                        return _s(this.CompleteGoalLocString("DailyChallengeGoal_PlayCardToFoundation"),
                            [
                                Card.GetSymbolStringFromShortName(this.Parameters[PlayCardDailyKlondikeAuthority.KeyCardToPlay]),
                                (this.AllowedTime > 0 ? this.GetTimeFormat(this.AllowedTime) : this.AllowedMoves),
                                this.AllowedMoves
                            ]);

                     case KlondikeChallenge.GoalType.PlayValues:
                         var numToPlay = 0;
                         var value =  Card.GetLongValueName(this.Parameters[PlayValuesDailyKlondikeAuthority.KeyValueToPlay]);
                         var param = this.Parameters[PlayValuesDailyKlondikeAuthority.KeyNumToPlay];
                         var numToPlay = parseInt(param);
                         var valueKey = "Card_" + value;
                         if (!isNaN(numToPlay) && numToPlay > 1)
                         {
                             if (value.toUpperCase() == "SIX")
                                 valueKey += "es";
                             else
                                 valueKey += "s";
                         }
                         value = _s(valueKey);

                         return _s(this.CompleteGoalLocString("DailyChallengeGoal_PlayValuesToFoundation"),
                             [
                                 numToPlay,
                                 value,
                                 (this.AllowedTime > 0 ? this.GetTimeFormat(this.AllowedTime) : this.AllowedMoves.toString()),
                                 this.AllowedMoves
                             ]);

                    default:
                        return "";
                }
            }
            catch (e) {
                return "";
            }
        };

        KlondikeChallenge.prototype.GetChallengeIconUrl = function () {
            return "klondike_challenge_btn_up.png"; // TODO - change this asset path?
        };

        KlondikeChallenge.prototype.GetModeName = function () {
            // return SolitaireGamesMap.Titles[SolitaireGameMode.Klondike];
            return "Klondike"; // TODO check this
        };

        KlondikeChallenge.prototype.GetShortGoalDescription = function () {
            switch (this.ChallengeType) {
                case KlondikeChallenge.GoalType.SolveGame:
                    if (this.AllowedMoves > 0)
                        return _s("Moves_Solve_Challenge");

                    if (this.AllowedTime > 0)
                        return _s("Timed_Solve_Challenge");

                    return _s("Solve_Challenge");

                case KlondikeChallenge.GoalType.PlayValues:
                case KlondikeChallenge.GoalType.PlayCard:
                    if (this.AllowedMoves > 0)
                        return _s("Moves_Card_Challenge");

                    if (this.AllowedTime > 0)
                        return _s("Timed_Card_Challenge");

                    return _s("DCTile_Card_Challenge");

                case KlondikeChallenge.GoalType.AchieveScore:
                    if (this.AllowedMoves > 0)
                        return _s("Moves_Score_Challenge");

                    if (this.AllowedTime > 0)
                        return _s("Timed_Score_Challenge");

                    return _s("Score_Challenge");

                default:
                    return "";
            }
        };

        KlondikeChallenge.MakeSolveAuthority = function (param) {  return new SolveGameDailyKlondikeAuthority(param); };
        KlondikeChallenge.MakeScoreAuthority = function (param) { return new AchieveScoreDailyKlondikeAuthority(param); };
        KlondikeChallenge.MakeCardToCardAuthority = function (param) {  return new CardToCardDailyKlondikeAuthority(param); };
        KlondikeChallenge.MakePlayCardAuthority = function (param) { return new PlayCardDailyKlondikeAuthority(param); };
        KlondikeChallenge.MakePlayValuesAuthority = function (param) { return new PlayValuesDailyKlondikeAuthority(param); };

        KlondikeChallenge.FromDictionary = function (spec) {
            var challengeType = parseInt(spec.Data["CHDEF_ChallengeType"]);
            var parameters = {};

            _.forEach(spec.Data, function (value, key) {
                if (key.indexOf("PARAM_") == 0) {
                    var nkey = key.substring(6);
                    parameters[nkey] = value;
                }
            });

            //spec.Remove("CHDEF_ChallengeType");

            var retval = new KlondikeChallenge(challengeType, parameters, spec);
            retval.FromDictionaryInternal(spec.Data);

            return retval;
        };

        KlondikeChallenge.FirstParameters =
        {
            "SolveGame": null,
            "AchieveScore": "ScoreRequired",
            "CardToCard": "StackCard",
            "PlayCard": "CardToPlay",
            "PlayValues": "NumToPlay"
        };

        KlondikeChallenge.SecondParameters =
        {
            "SolveGame": null,
            "AchieveScore": null,
            "CardToCard": "BaseCard",
            "PlayCard": null,
            "PlayValues": "ValueToPlay"
        };

        KlondikeChallenge.AuthorityTypes = [
            KlondikeChallenge.MakeSolveAuthority,
            KlondikeChallenge.MakeScoreAuthority,
            KlondikeChallenge.MakeCardToCardAuthority,
            KlondikeChallenge.MakePlayCardAuthority,
            KlondikeChallenge.MakePlayValuesAuthority
        ];


        return KlondikeChallenge;

    });

